import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Briefcase, Star } from "lucide-react";
import { toast } from "sonner";

const TABS = [["pending_review", "Da approvare"], ["approved", "Approvati"], ["more_information_required", "Info richieste"], ["rejected", "Rifiutati"], ["suspended", "Sospesi"]];

export default function ProVerification() {
  const [tab, setTab] = useState("pending_review");
  const [items, setItems] = useState([]);
  const [reason, setReason] = useState({});
  const load = async () => { const { data } = await api.get("/ceo/professionals", { params: { status: tab } }); setItems(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const act = async (id, action) => {
    try { await api.put(`/ceo/professionals/${id}/status`, { action, reason: reason[id] || "" }); toast.success("Aggiornato"); setReason({ ...reason, [id]: "" }); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2 flex-wrap">
        {TABS.map(([k, l]) => <button key={k} data-testid={`protab-${k}`} onClick={() => setTab(k)} className={`text-sm rounded-full px-3 py-1.5 border ${tab === k ? "bg-[#00E676]/15 border-[#00E676] text-[#00E676]" : "border-white/10 text-zinc-300"}`}>{l}</button>)}
      </div>
      {items.length === 0 && <div className="text-zinc-500 py-8 text-center">Nessun professionista in questa sezione.</div>}
      <div className="space-y-3">
        {items.map((p) => (
          <div key={p.id} data-testid={`pro-verify-${p.id}`} className="bg-[#1C1C1F] border border-white/10 rounded-lg p-4">
            <div className="flex gap-3">
              <div className="h-14 w-14 shrink-0 rounded-xl overflow-hidden bg-[#0A0A0C] border border-white/10 flex items-center justify-center">{p.photo ? <img src={p.photo} alt="" className="h-full w-full object-cover" /> : <Briefcase className="h-5 w-5 text-zinc-500" />}</div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold">{p.name}</div>
                <div className="text-xs text-[#00E676]">{(p.categories || []).join(" · ")}</div>
                <div className="text-xs text-zinc-400">{p.contact_phone} · {p.zone} · {(p.service_modes || []).join(", ")}</div>
                {p.rating > 0 && <div className="text-xs text-amber-300 flex items-center gap-0.5"><Star className="h-3 w-3 fill-amber-300" /> {p.rating} ({p.reviews_count})</div>}
              </div>
            </div>
            {p.description && <p className="text-sm text-zinc-400 mt-2">{p.description}</p>}
            {p.rejection_reason && <div className="text-xs text-amber-400 mt-1">Nota: {p.rejection_reason}</div>}
            {["pending_review", "approved", "more_information_required"].includes(tab) && (
              <Textarea data-testid={`reason-${p.id}`} value={reason[p.id] || ""} onChange={(e) => setReason({ ...reason, [p.id]: e.target.value })} placeholder="Motivazione (per rifiuto/info/sospensione)" className="bg-[#0A0A0C] border-white/10 mt-3 text-sm" />
            )}
            <div className="flex gap-2 mt-3 flex-wrap">
              {tab === "pending_review" && <>
                <Button size="sm" data-testid={`approve-${p.id}`} onClick={() => act(p.id, "approve")} className="bg-[#00E676] text-black">Approva</Button>
                <Button size="sm" variant="secondary" data-testid={`info-${p.id}`} onClick={() => act(p.id, "request_info")}>Richiedi info</Button>
                <Button size="sm" variant="destructive" data-testid={`reject-${p.id}`} onClick={() => act(p.id, "reject")}>Rifiuta</Button>
              </>}
              {tab === "approved" && <Button size="sm" variant="destructive" data-testid={`suspend-${p.id}`} onClick={() => act(p.id, "suspend")}>Sospendi</Button>}
              {(tab === "rejected" || tab === "suspended" || tab === "more_information_required") && <Button size="sm" data-testid={`reactivate-${p.id}`} onClick={() => act(p.id, "reactivate")} className="bg-[#00E676] text-black">Riattiva/Approva</Button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
